import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/ArrowBendDownLeft.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...r, weights: a }));
e.displayName = "ArrowBendDownLeftIcon";
const w = e;
export {
  w as ArrowBendDownLeft,
  e as ArrowBendDownLeftIcon
};
